module.exports = __webpack_public_path__ + "static/img/28.878dcc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotKeywordsMap/map/28.png
// module id = fRBO
// module chunks = 2